<!-- TableOfContent.vue -->
<template>
    <div class="table-contents" v-if="props.contentSelector">
        <h3 v-if="props.title" >{{ title }}</h3>
        <ul class="tableContents">
            <li  v-for="(header, index) in headers" :key="index">
                <a class="scroll" :href="`#${header.id}`">{{ header.text }}</a>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, onMounted, defineProps } from 'vue';

const props = defineProps(['title', 'contentSelector']);

const headers = ref([]);

onMounted(() => {
    const contentElement = document.querySelector(props.contentSelector);
    if (contentElement) {
        const headingElements = contentElement.querySelectorAll('h2, h3');
        headers.value = Array.from(headingElements).map((heading, index) => {
            const ref = heading.hasAttribute("id") ? heading.getAttribute("id") : `toc_${index}`;
            if (!heading.hasAttribute("id")) {
                heading.setAttribute("id", ref);
            }

            return {
                id: ref,
                text: heading.textContent.trim(),
            };
        });
    }
});
</script>

<style scoped>
.tableContents {
    padding: 0;
    list-style: none;
}
</style>
